import { useEventContent } from "@/context/EventContentContext";

export default function Program() {
  const { program } = useEventContent();

  return (
    <div data-testid="program-page" className="section-pad">
      <div className="container-cg">
        <div className="overline text-[var(--brand-primary)]">Programa</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          Minuto a minuto de la velada
        </h1>
        <p className="max-w-2xl mt-5 text-[var(--brand-muted)] leading-relaxed">
          Una secuencia pensada para acompañar al comensal desde la recepción hasta el cierre conmemorativo.
        </p>

        <div className="mt-14 relative">
          <div className="absolute left-3 md:left-1/2 top-0 bottom-0 w-px bg-[var(--brand-border)]" />
          <ol className="space-y-10">
            {program.map((p, idx) => (
              <li
                key={p.time}
                data-testid={`program-item-${idx}`}
                className={`relative md:grid md:grid-cols-2 md:gap-10 ${
                  idx % 2 === 0 ? "" : "md:[&>div:first-child]:order-2"
                }`}
              >
                {/* dot */}
                <span
                  className="absolute left-3 md:left-1/2 top-2 -translate-x-1/2 w-3 h-3 rounded-full bg-[var(--brand-accent)] ring-4 ring-[var(--brand-bg)]"
                  aria-hidden
                />
                <div className="pl-10 md:pl-0 md:text-right md:pr-10">
                  <div className="overline text-[var(--brand-primary)]">{p.time} hrs</div>
                  <h3 className="font-serif-cg text-2xl md:text-3xl tracking-tight mt-2">{p.title}</h3>
                </div>
                <div className="pl-10 md:pl-10 mt-2 md:mt-0 text-[var(--brand-ink)]/80 leading-relaxed">
                  {p.description}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}
